"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNumberState = void 0;
var react_1 = require("react");
exports.useNumberState = function () { return react_1.useState(0); };
//# sourceMappingURL=useNumberState.js.map